module.exports = __webpack_public_path__ + "img/marker_four_cyan1.16a36db7.png";